/* jshint esversion: 6 */
import axios from 'axios';

axios.defaults.headers.common.token = localStorage.getItem('token') || 'token';
axios.defaults.headers.common.appId = localStorage.getItem('appId') || 'appId';
const instance = axios.create({
    baseURL: process.env.VUE_APP_WEB_API
});
    
export default instance;